// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remain-class[data-v-0d2b28cc] {\n  font-size: 13px;\n}", ""]);
// Exports
module.exports = exports;
